<!-- Card Header Start-->

<div class=" pt-4 pb-3">
  <div class="px-5">
    <div class="flex justify-between items-center mb-4">
      <div class="flex gap-1 flex-grow">
        <img src="./assets/images/icons/tickets/search-black.svg" alt="">
        <input type="text" placeholder="Type & hit enter..."
          class="px-1 py-2 border-none outline-none text-[#9F9FA9CC] font-normal text-xs leading-normal w-full"
          [(ngModel)]="searchModel.search" (keydown.enter)="changeSearch()" (keydown)="preventCharacters($event)" (paste)="handlePaste($event)" />
      </div>
      <button class="size-5 rounded-md flex justify-center items-center outline-0 hover:bg-black cursor-pointer group"
        [mat-dialog-close]="true" (click)="cancel()">

        <!-- Gray cross (default) -->
        <img src="./assets/images/icons/global/popup-cross.svg" class="block group-hover:hidden" alt="gray cross"
          height="10" width="10">

        <!-- White cross (on hover) -->
        <img src="./assets/images/icons/global/popup-cross-white.svg" class="hidden group-hover:block" alt="white cross"
          height="10" width="10">
      </button>
    </div>
    <div class="flex justify-between items-center">
      <ul class="text-sm leading-5 font-medium text-[#9F9FA9] gap-7 flex">
        <li class="pb-3 cursor-pointer border-b-2 border-[#1379F0]">Mixed</li>
        <li class="pb-3 cursor-pointer">Settings</li>
        <li class="pb-3 cursor-pointer">Integrations</li>
        <li class="pb-3 cursor-pointer">Users</li>
        <li class="pb-3 cursor-pointer">Docs</li>
      </ul>
      <span class="p-1 hover:bg-gray-200 rounded-md cursor-pointer">
        <img src="./assets/images/icons/global/setting-black.svg" alt="">
      </span>
    </div>
  </div>
  <div class="border-b border-[#EBEBEE]"></div>

  <mat-dialog-content class="mat-typography !pt-0 !px-0">

    <div class="border-b border-[#EBEBEE] p-6 px-3.5">
      <h1 class="text-[#4A5565] text-xs font-medium leading-4 mb-3.5">Settings</h1>
      <ul class="text-[#27272A] text-sm font-medium leading-5 space-y-1.5  ">
        <li class="flex items-center gap-2 hover:bg-[#f6f3f4] py-1.5 px-2.5 rounded-md cursor-pointer">
          <img src="../../../assets/images/icons/global/public-profile.svg" alt="">
          <span>Public Profile</span>
        </li>
        <li class="flex items-center gap-2 hover:bg-[#f6f3f4] py-1.5 px-2.5 rounded-md cursor-pointer">
          <img src="../../../assets/images/icons/global/my-account.svg" alt="">
          <span>My Account</span>
        </li>
        <li class="flex items-center gap-2 hover:bg-[#f6f3f4] py-1.5 px-2.5 rounded-md cursor-pointer">
          <img src="../../../assets/images/icons/global/devs-forums.svg" alt="">
          <span>Devs Forum</span>
        </li>
      </ul>
    </div>
    <div class="border-b border-[#EBEBEE] p-6">
      <h1 class="text-[#4A5565] text-xs font-medium leading-4 mb-3.5">Integrations</h1>
      <ul class="space-y-5">
        <li class="flex justify-between items-center gap-2 hover:bg-[#f6f3f4] py-1.5 px-2.5 rounded-md ">
          <div class="flex items-center gap-2">
            <div class="p-2 ring ring-[#EBEBEE] bg-[#F3F4F699] rounded-full">
              <img src="'../../../../../assets/images/icons/global/jira.svg.svg" alt="">
            </div>
            <div>
              <h3 class="text-xs font-semibold leading-5 text-[#09090B] mb-1">Jira</h3>
              <p class="font-medium text-xs leading-4 text-[#4A5565]">Project management</p>
            </div>
          </div>
          <div>
            <div class="flex items-center gap-1">
              <!-- Show first 3 avatars -->
              <div class="flex -space-x-2">
                <ng-container *ngFor="let usr of item.userList.slice(0, 3);">
                  <app-avatar [userList]="[{displayName: usr.displayName, pic: null}]" size="sm"></app-avatar>
                </ng-container>
                <!-- Show +N with tooltip for remaining users -->
                <div *ngIf="item.userList.length > 3"
                  class="shrink-0 rounded-full ring-1 ring-white flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative bg-[#F3F4F6] text-[#4A5565] size-[22px]"
                  [matTooltip]="getRemainingNames(item.userList)">
                  +{{ item.userList.length - 3 }}
                </div>
              </div>

            </div>
          </div>
        </li>
        <li class="flex justify-between items-center gap-2 hover:bg-[#f6f3f4] py-1.5 px-2.5 rounded-md">
          <div class="flex items-center gap-2">
            <div class="p-2 ring ring-[#EBEBEE] bg-[#F3F4F699] rounded-full">
              <img src="'../../../../../assets/images/icons/global/Inferno.svg" alt="">
            </div>
            <div>
              <h3 class="text-xs font-semibold leading-5 text-[#09090B] mb-1">Inferno</h3>
              <p class="font-medium text-xs leading-4 text-[#4A5565]">Real-time photo sharing app</p>
            </div>
          </div>
          <div>
            <div class="flex items-center gap-1">
              <!-- Show first 3 avatars -->
              <div class="flex -space-x-2">
                <ng-container *ngFor="let usr of item.userList.slice(0, 3);">
                  <app-avatar [userList]="[{displayName: usr.displayName, pic: null}]" size="sm"></app-avatar>
                </ng-container>
                <!-- Show +N with tooltip for remaining users -->
                <div *ngIf="item.userList.length > 3"
                  class="shrink-0 rounded-full ring-1 ring-white flex items-center justify-center font-medium text-[10px] uppercase hover:z-10 relative bg-[#F3F4F6] text-[#4A5565] size-[22px]"
                  [matTooltip]="getRemainingNames(item.userList)">
                  +{{ item.userList.length - 3 }}
                </div>
              </div>


            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="border-b border-[#EBEBEE] p-6">
      <h1 class="text-[#4A5565] text-xs font-medium leading-4 mb-3.5">Users</h1>
      <ul class="space-y-5">
        <li class="flex justify-between items-center gap-2 hover:bg-[#f6f3f4] py-1.5 px-2.5 rounded-md">
          <div class="flex items-center gap-2">
            <app-avatar [userList]="[{displayName: 'Tyler Hero', pic: '../../../../../assets/images/avatars/300-13.png'}]"
              size="2xl"></app-avatar>
            <div>
              <h3 class="text-xs font-semibold leading-5 text-[#09090B] mb-1">Tyler Hero</h3>
              <p class="font-medium text-xs leading-4 text-[#4A5565]">{{"tyler.hero@gmail.com connections"}}</p>
            </div>
          </div>
          <div class="flex justify-end items-center gap-3">
            <span
              class="badge badge-outline badge-success !inline-flex items-center justify-center gap-1.5 !rounded-3xl">
              <span class="inline-block rounded-full size-1.5 border bg-[#008236]"></span>
              <span>In Office</span>
            </span>
            <button
              class="size-6 flex items-center justify-center rounded transition cursor-pointer hover:bg-[#F8F8FA]">
              <img src="../../../../../../assets/images/icons/tickets/three-dots.svg" alt="">
            </button>
          </div>
        </li>
        <li class="flex justify-between items-center gap-2 hover:bg-[#f6f3f4] py-1.5 px-2.5 rounded-md">
          <div class="flex items-center gap-2">
            <app-avatar [userList]="[{displayName: 'Esther Howard', pic: '../../../../../assets/images/avatars/300-22.png'}]"
              size="2xl"></app-avatar>
            <div>
              <h3 class="text-xs font-semibold leading-5 text-[#09090B] mb-1">Esther Howard</h3>
              <p class="font-medium text-xs leading-4 text-[#4A5565]">{{"tyler.hero@gmail.com connections"}}</p>
            </div>
          </div>
          <div class="flex justify-end items-center gap-3">
            <span
              class="badge badge-outline badge-danger !inline-flex items-center justify-center gap-1.5 !rounded-3xl">
              <span class="inline-block rounded-full size-1.5 border bg-[#E7000B]"></span>
              <span>On Leave</span>
            </span>
            <button
              class="size-6 flex items-center justify-center rounded transition cursor-pointer hover:bg-[#F8F8FA]">
              <img src="../../../../../../assets/images/icons/tickets/three-dots.svg" alt="">
            </button>
          </div>
        </li>
      </ul>
    </div>
  </mat-dialog-content>

</div>
<!-- Card Header End-->
